var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import _Handlebars2 from "../../../../packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js";
import { View, loc } from "../../../../packages/@okta/courage-dist/esm/src/CourageForSigninWidget.js";
import "../../../../packages/@okta/courage-dist/esm/src/courage/framework/Model.js";
import "../../../../packages/@okta/courage-dist/esm/src/courage/vendor/lib/backbone.js";
import oktaJQueryStatic from "../../../../packages/@okta/courage-dist/esm/src/courage/util/jquery-wrapper.js";
import oktaUnderscore from "../../../../packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js";
import "../../../../packages/@okta/courage-dist/esm/src/courage/models/Model.js";
import "../../../../packages/@okta/courage-dist/esm/src/courage/models/BaseModel.js";
import "../../../../packages/@okta/courage-dist/esm/src/courage/framework/View.js";
import "../../../../packages/@okta/courage-dist/esm/src/courage/views/Backbone.ListView.js";
import fn from "../../../util/Animations.js";
function setBackgroundImage(el, appState) {
  const imgSrc = appState.get("securityImage");
  const imgDescription = appState.get("securityImageDescription");
  const isUndefinedUser = appState.get("isUndefinedUser");
  const isNewUser = appState.get("isNewUser");
  const isSecurityImage = !isUndefinedUser && !isNewUser;
  el.css("background-image", "");
  el.removeClass("new-user undefined-user");
  if (isNewUser) {
    el.addClass("new-user");
    return;
  }
  if (isUndefinedUser) {
    el.addClass("undefined-user");
    return;
  }
  if (isSecurityImage) {
    el.removeAttr("aria-describedby");
    el.find(".accessibility-text").text(imgDescription);
    el.css("background-image", "url(" + oktaUnderscore.escape(imgSrc) + ")");
    return;
  }
}
function antiPhishingMessage(image, host) {
  oktaJQueryStatic(window).on("resize.securityBeaconQtip", oktaUnderscore.debounce(function() {
    if (image.is(":visible")) {
      image.qtip("show");
    }
  }, 300));
  image.qtip({
    prerender: true,
    content: {
      text: loc("primaryauth.newUser.tooltip", "login", [oktaUnderscore.escape(host)]),
      button: loc("primaryauth.newUser.tooltip.close", "login")
    },
    style: {
      classes: "okta-security-image-tooltip security-image-qtip qtip-custom qtip-shadow qtip-rounded",
      tip: {
        height: 12,
        width: 16
      }
    },
    position: {
      my: "top center",
      at: "center",
      target: oktaJQueryStatic(".auth-beacon-security"),
      adjust: {
        method: "flip",
        scroll: false,
        resize: true
      },
      effect: false
    },
    hide: {
      event: false,
      fixed: true
    },
    show: {
      event: false,
      delay: 200
    },
    events: {
      move: function(event, api) {
        if (!api.elements.target.is(":visible")) {
          api.set("hide.effect", false);
          api.hide();
          api.set("hide.effect", true);
        }
      }
    }
  });
  setTimeout(() => {
    image.qtip("toggle", image.is(":visible"));
  }, 0);
}
function destroyAntiPhishingMessage(image) {
  image.qtip("destroy");
  oktaJQueryStatic(window).off("resize.securityBeaconQtip");
}
function updateSecurityImage($el, appState, animate) {
  return __async(this, null, function* () {
    const image = $el.find(".auth-beacon-security");
    const border = $el.find(".js-auth-beacon-border");
    const hasBorder = !appState.get("isUndefinedUser");
    const hasAntiPhishing = appState.get("isNewUser");
    const radialProgressBar = $el.find(".radial-progress-bar");
    const host = appState.get("baseUrl").match(/https?:\/\/(.[^/]+)/)[1];
    const duration = 200;
    if (!animate) {
      setBackgroundImage(image, appState);
      border.toggleClass("auth-beacon-border", hasBorder);
      return;
    }
    destroyAntiPhishingMessage(image);
    if (!hasBorder) {
      image.fadeOut(duration, function() {
        setBackgroundImage(image, appState);
        border.removeClass("auth-beacon-border");
        image.fadeIn(duration);
      });
    } else {
      border.removeClass("auth-beacon-border");
      yield fn.radialProgressBar({
        $el: radialProgressBar,
        swap: function() {
          image.fadeOut(duration, () => {
            setBackgroundImage(image, appState);
            image.fadeIn(duration);
          });
        }
      });
      border.addClass("auth-beacon-border");
      if (hasAntiPhishing) {
        antiPhishingMessage(image, host);
      }
    }
  });
}
var SecurityBeacon = View.extend({
  template: _Handlebars2.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function(container, depth0, helpers, partials, data) {
      return '<div class="beacon-blank"><div class="radial-progress-bar"><div class="circle left"></div><div class="circle right"></div></div></div><div aria-live="polite" role="img" class="bg-helper auth-beacon auth-beacon-security" data-se="security-beacon"><span class="accessibility-text"></span><div class="okta-sign-in-beacon-border auth-beacon-border js-auth-beacon-border"></div></div>';
    },
    "useData": true
  }),
  className: "js-security-beacon",
  initialize: function(options) {
    this.update = oktaUnderscore.partial(updateSecurityImage, this.$el, options.appState);
    this.listenTo(options.appState, "change:securityImage", this.update);
    this.listenTo(options.appState, "loading", function(isLoading) {
      this.$el.toggleClass("beacon-loading", isLoading);
      this.removeAntiPhishingMessage();
    });
    this.options.appState.set("beaconType", "security");
    this.listenTo(options.appState, "navigate", this.removeAntiPhishingMessage);
  },
  postRender: function() {
    this.update(false);
  },
  equals: function(Beacon) {
    return Beacon && this instanceof Beacon;
  },
  removeAntiPhishingMessage: function() {
    const image = this.$el.find(".auth-beacon-security");
    image.qtip("destroy");
  }
});
export { SecurityBeacon as default };
